<template>
	<edit-template ref="edit" style="padding: 24rem;box-sizing: border-box" @confirm="save('form')" @cancel="open" :cancelRemind="false" confirmText="保存" cancelText="取消">
		
    <!-- 大表单 -->
    <div>
      <el-form ref="form" :model="form" :rules="rules" label-position="left" label-width="100rem">
        <el-form-item label="选择校区" prop="school_id">
          <el-select v-model="form.school_id" :popper-append-to-body="false" placeholder="请选择校区" @change="changeSchool">
            <el-option v-for="item in campusArr" :label="item.school_name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="选择楼宇" prop="building_id">
          <el-select v-model="form.building_id" :popper-append-to-body="false" placeholder="请选择楼宇" @change="changeBuilding">
            <el-option v-for="(item, index) in buildingArr" :label="item.dimicile_buliding_name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="选择楼层" prop="storey">
          <el-select v-model="form.storey" :popper-append-to-body="false" placeholder="请选择楼层">
            <el-option v-for="item in floorArr" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="教室名称" prop="addr_name">
          <el-input v-model="form.addr_name" maxlength="20" placeholder="请输入教室名称"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <!-- 底部按钮 -->
    
  
</edit-template>
</template>

<script>
export default {
	_config:{"route":{"path":"add","meta":{"title":"新增"}}},
  data() {
    return {
      form: {storey: '', addr_name: '', school_id: '', building_id: ''},
      campusArr: [],
      buildingArr: [],
      floorArr: [],
      subjectsArr: [],
      rules: {
        school_id: [{required: true, message: '请选择校区', trigger: 'change'}],
        building_id: [{required: true, message: '请选择楼宇', trigger: 'change'}],
        storey: [{required: true, message: '请选择楼层', trigger: 'change'}],
        addr_name: [{required: true, message: '请输入教室名称', trigger: 'change'}],
      },
      options: []
    }
  },

  methods: {
    save(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          this.$_axios2.post('api/place/add-place', this.form, {logic: 1}).then(() => {
            this.$message({
              type: 'success',
              message: '添加成功!'
            })
            setTimeout(() => {
              this.$store.commit('setPage', 1)
              this.$router.back()
            }, 20)
          })
        }
      })
    },
    open() {
      this.$confirm('是否取消新增', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.back()
      })
    },
    changeBuilding(val) {
      this.floorArr = []
      this.form.storey = ''
      this.buildingArr.forEach((item, index) => {
        if (val == item.id) {
          for (let index = item.floor_min; index <= item.floor_max; index++) {
            if (index !== 0) this.floorArr.push(index)
          }
        }
      })
    },
    changeSchool(val) {
      this.buildingArr = []
      this.floorArr = []
      this.form.building_id = ''
      this.form.storey = ''
      this.$_axios2.get('api/1v1/place/get-building?school_id=' + val + '&type=2').then(res => {
        this.buildingArr = res.data.data
      })
    }
  },

  created() {
    this.$_axios.get('site/school').then(res => {
      this.campusArr = res.data.data
    })
    // this.$_axios.get('site/fist-subject').then(res => {
    //   this.subjectsArr = res.data.data
    // })
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__label {
  font-size: 16rem;
  font-weight: 600;
  color: #333333;
}
</style>
